<template>
	<div class="ai_container">
		<Header :title="'상담 매장 선택'" :onPrev="handlePrev" :isShowHome="true" :returnName="'AiEstimate'" />
		<div class="tmap_region_wrapper">
			<div class="heading_11" @click="handleRegionModalOpen">
				{{ selectLocation }}
				<img src="/static/icons/arrow/chevron_down.svg" />
			</div>
			<button class="body_10_M">
				내 위치 : {{ currLocation }}
			</button>
		</div>
		<div ref="tmap" class="tmap_wrapper" />
		<BottomSheet :isVisible="true" ref="bottomSheetHandle">
			<ul class="shop_card_list">
				<ul v-for="item in showPartnerList" v-bind:key="item.agent_no">
					<ShopCard
						v-on:refreshShopList="refreshShopList"
						:name="item.agent_name"
						:address="item.address"
						:distance="item.distance+'km'"
						:contact="item.phone_number"
						:status="item.send_yn+item.use_yn"
						:agentNo="item.agent_no.toString()"
						:estimateSeq="estimateSeq.toString()"
						:datEstimateNo="datEstimateNo.toString()"
						:isBest="item.best_yn"
						:onClick="() => labelOnClick(item.lat,item.lng,true)"
					/>
				</ul>
			</ul>
		</BottomSheet>
		<Alert :isVisible="isAlert.isOpenAlert" :title="isAlert.title" :content="isAlert.content" :secondaryText="'닫기'"
			:onClickSecondary="() => handleAlertClose()" />
		<Alert :isVisible="isAlert1.isOpenAlert" :title="isAlert1.title" :content="isAlert1.content" :secondaryText="'뒤로가기'"
			:onClickSecondary="() => handleAlertClose1()" />
		<Modal :isVisible="isOpenRegionModal" :title="'지역 선택'" :onClose="handleRegionModalClose">
			<div class="current_location_wrapper">
				<img src="/static/icons/spot.svg" />
				<span class="body_8 f_red_3" @click="handleSetcurrLocate()">현재 위치로 검색</span>
				<img src="/static/icons/arrow/arrow_small_right.svg" />
				<span class="body_8">{{selectLocation}}</span>
			</div>
			<div class="region_wrapper">
				<ul>
					<li v-for="item in sidoList" :key="item.sido_cd"
						:class="`${item.sido_cd === sido_cd ? 'selected f_gray_12' : ''}`"
						@click="() => handleSidoClick(item)">
						{{ item.sido_nm }}
						<img v-if="item.sido_cd === sido_cd" src="/static/icons/select_check.svg" width="20" />
					</li>
				</ul>
				<ul>
					<li v-for="item in zoneList[sido_cd]" :key="item.sigungu_cd"
						:class="`${item.sigungu_cd === sigungu_cd ? 'selected f_gray_12' : ''}`"
						@click="() => handleSigunguClick(item)">
						{{ item.sigungu_nm }}
						<img v-if="item.sigungu_cd === sigungu_cd" src="/static/icons/select_check.svg" width="20" />
					</li>
				</ul>
			</div>
		</Modal>
	</div>
</template>

<script>
import Vue from 'vue'
import Header from '../../components/ai/AiHeader.vue'
import BottomSheet from '../../components/ai/AiBottomSheet.vue'
import ShopCard from '../../components/ai/card/AiShopCard.vue'
import Alert from '../../components/ai/AiAlert.vue'
import Modal from '../../components/ai/AiModal.vue'

export default {
	data() {
		return {
			isOpenRegionModal: false,
			map:'',
			marker:'',
			markers:[],
			currLocation: '',
			carrlat:'',
			currlng:'',
			selectLocation:'',
			isAlert:{
				isOpenAlert:false,
				title:'',
				content:''
			},
			isAlert1: {
				isOpenAlert: false,
				title: ''
			},

			_responseData:'',
			partnerList:[],
			showPartnerList:[],
			sido_cd: '',
			sigungu_cd: '',
			sidoList:[],
			zoneList:[]
		}
	},
	computed:{
		estimateSeq(){
			if(Vue.$sessionStorage.get('redirectseq')){
				return Vue.$sessionStorage.get('redirectseq')
			} else {
				this.isAlert1.isOpenAlert = true;
				this.isAlert1.title = `비정상적인 접근입니다.`
				return;
			}
		},
		datEstimateNo(){
			if(Vue.$sessionStorage.get('datEstimateNo')){
				return Vue.$sessionStorage.get('datEstimateNo')
			} else {
				this.isAlert1.isOpenAlert = true;
				this.isAlert1.title = `비정상적인 접근입니다.`
				return;
			}
		},
	},
	methods: {
		labelOnClick(lat,lng,flag) {
			this.map.setCenter(new Tmapv2.LatLng(lat, lng))
			this.map.setZoom(14)

			if(flag){
				this.$refs.bottomSheetHandle.handledrag();
			}
		},

		handlePrev() { },
		handleAlertClose() {
			this.isAlert.isOpenAlert= false;
		},
		handleRegionModalOpen() {
			this.isOpenRegionModal = true
		},
		handleRegionModalClose() {
			var zoneCode=this.sido_cd+this.sigungu_cd;
			if(zoneCode.length == 0){
				this.markers.forEach((item)=>{
					item.setVisible(true)
				})
			} else if (zoneCode.length == 2 || zoneCode.length ==5){
				var x = this.partnerList.filter(item =>
					item.address.includes(this.selectLocation)
				);
				this.fnSetLocationPartnerList(x)

				this.markers.forEach((item)=>{
					if(item.currYn!=='Y'){
						if(item.zoneCode.startsWith(zoneCode)){
							item.setVisible(true)
						} else {
							item.setVisible(false)
						}
					}
				})
			} else {

			}

			this.isOpenRegionModal = false
		},
		handleSidoClick(value) {
			this.sido_cd = value.sido_cd
			this.sigungu_cd = ''
			this.selectLocation = value.sido_nm
		},
		handleSigunguClick(value) {
			this.sigungu_cd = value.sigungu_cd
			this.selectLocation = value.sido_nm+' '+value.sigungu_nm
		},

		handleSetcurrLocate(){
			this.fnInitMap(this.currlat, this.currlng, true);
			this.fnSetLocationPartnerList(this.partnerList, true);
			this.sido_cd = ''
			this.sigungu_cd = ''
			this.selectLocation = this.currLocation
			this.isOpenRegionModal = false
		},

		fnGetCurrGeoCode(){
			this.map = new Tmapv2.Map(this.$refs.tmap, {
				center: new Tmapv2.LatLng(37.566481622437934, 126.98502302169841),
				zoom: 14
			})

			if(!this.map){
				this.isAlert.isOpenAlert= true;
				this.isAlert.title='지도를 로드하는 중 오류가 발생하였어요.'
				this.isAlert.content='잠시후 다시 시도해주세요.'
			}

			// 위치 정보 조회.
			let lat, lng;
			var options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0,
			};

			navigator.geolocation.getCurrentPosition((position) => {
				lat = position.coords.latitude;
				lng = position.coords.longitude;

				this.fnInitMap(lat, lng, true);
			},(fail)=>{
				lat = 37.5512111;
				lng = 126.9882;

				this.fnInitMap(lat, lng, false);
			}, options);
		},

		fnInitMap(curlat, curlng, status) {
			this.currlat = curlat;
			this.currlng = curlng;

			if (!status) {
				this.isAlert.isOpenAlert = true;
				this.isAlert.title = '위치정보를 받아올 수 없어요';
				this.isAlert.content = '지역 필터로 위치를 선택해주세요';
				this.loadGetLonLatFromAddress(curlat,curlng)
			} else {
				this.loadGetLonLatFromAddress(curlat,curlng)
			}

			// 지도 중심 설정
			this.map.setCenter(new Tmapv2.LatLng(this.currlat, this.currlng));

			if (!this.currMarker) {
				// 현재 위치 마커 생성 (한 번만 생성)
				this.currMarker = new Tmapv2.Marker({
					position: new Tmapv2.LatLng(this.currlat, this.currlng),
					icon: "/static/images/ai/spot.png",
				});
				this.currMarker.currYn = 'Y';
				this.currMarker.setMap(this.map);
				this.markers.push(this.currMarker);
			} else {
				// 기존 마커 위치 업데이트
				this.currMarker.setPosition(new Tmapv2.LatLng(this.currlat, this.currlng));
			}

			this.fnGetPartnerGeoCode();
		},

		fnGetPartnerGeoCode() {
			var $this = this;
			Vue.httpClient
			.post('/m/ai/dat/getPartner', { estimateSeq: this.estimateSeq })
			.then(response => {
				if (response.data.result) {
					$this.partnerList = response.data.result;

					// 기존 마커 초기화 (현재 위치 마커 제외)
					$this.markers.forEach(marker => {
						if (marker.currYn !== 'Y') {
							marker.setMap(null);
						}
					});
					$this.markers = $this.markers.filter(marker => marker.currYn === 'Y');

					// 새로운 파트너 마커 추가
					$this.partnerList.forEach((item) => {
						$this.marker = new Tmapv2.Marker({
							position: new Tmapv2.LatLng(item.lat, item.lng),
						});
						$this.marker.setMap($this.map);
						$this.marker.currYn = 'N';
						$this.marker.zoneCode = item.zone_code;

						// 마커 가시성 처리 (초기 설정)
						var zoneCode = $this.sido_cd + $this.sigungu_cd;
						if (zoneCode.length > 0 && !item.address.includes($this.selectLocation)) {
							$this.marker.setVisible(false);
						}

						$this.markers.push($this.marker);

						// 거리 계산
						var distance = $this.currMarker.getPosition().distanceTo($this.marker.getPosition());
						item.distance = Math.round(distance / 100) / 10;
					});

					this.fnSetLocationPartnerList(this.partnerList, true);
					this.handleRegionModalClose();
				} else {
					throw new Error(response.data.message || '');
				}
			})
			.catch((e) => {
				var msg = '';
				if(e.data){
					if(e.data.result){
						msg = e.data.result.message
					}
				} else {
					msg = `오류가 발생하였습니다\n관리자에게 문의 바랍니다`
				}

				this.isAlert1.isOpenAlert = true;
				this.isAlert1.title = `${msg}`
			})
			.finally(() => {});
		},

		fnSetLocationPartnerList(partnerList, isInit){
			// 우선공업사 먼저
			// 우수공업사일경우 우선순위 순,
			// 우수공업사가 아닐경우 거리순
			this.showPartnerList = partnerList.sort((a, b) =>{
				if (a.best_yn === b.best_yn) {
					// best_yn이 동일한 경우
					if (a.best_yn === "Y") {
						// priority가 null 또는 빈 문자열인 경우 기본값 설정
						const priorityA = a.priority ? parseInt(a.priority, 10) : Number.MAX_SAFE_INTEGER;
						const priorityB = b.priority ? parseInt(b.priority, 10) : Number.MAX_SAFE_INTEGER;
						return priorityA - priorityB; // priority로 정렬
					} else {
						return a.distance - b.distance; // distance로 정렬
					}
				}
			});

			if(!isInit){
				this.labelOnClick(this.showPartnerList[0].lat,this.showPartnerList[0].lng,true)
			} else {
				this.labelOnClick(this.currlat,this.currlng,false)
			}
		},
		refreshShopList(){
			this.fnGetPartnerGeoCode();
		},

		fnGetZoneCode(){
			Vue.httpClient
			.post('/m/ai/dat/getZoneCode')
			.then(response => {
				// status 먼저
				if (response.data.result) {

					// zone코드 중복 제거거
					const result = response.data.result.filter((item, index, self) =>
						index === self.findIndex((t) => t.sido_cd+t.sigungu_cd === item.sido_cd+item.sigungu_cd)
					);

					this.zoneList =
					result.reduce((result,current)=>{
						result[current.sido_cd] = result[current.sido_cd] || [];
						result[current.sido_cd].push(current)
						return result
					},{})

					var remapZoneList =
					result.reduce((result,current)=>{
						result[current.sido_cd+','+current.sido_nm] = result[current.sido_cd+','+current.sido_nm] || [];
						result[current.sido_cd+','+current.sido_nm].push(current)
						return result
					},{})

					Object.keys(remapZoneList).forEach((item)=>{
						var code = item.split(",")[0];
						var name = item.split(",")[1];
						this.sidoList.push({sido_cd:code,sido_nm:name})
					})
				} else {
				}
			})
			.finally(_ => {
			});
		},

		//////////// 티맵 현재위치명 get method ///////////////////
		loadGetLonLatFromAddress(curlat, curlng) {
		// 티맵 현재위치 명 함수
			var tData = new Tmapv2.extension.TData();

			var optionObj = {
				coordType: "WGS84GEO",       //응답좌표 타입 옵션 설정 입니다.
				addressType: "A04"           //주소타입 옵션 설정 입니다.
			};

			var params = {
				onComplete:this.onComplete.bind(this),      //데이터 로드가 성공적으로 완료 되었을때 실행하는 함수 입니다.
				onProgress:this.onProgress.bind(this),      //데이터 로드 중에 실행하는 함수 입니다.
				onError:this.onError.bind(this)             //데이터 로드가 실패했을때 실행하는 함수 입니다.
			};
			// TData 리버스지오코딩 함수
			tData.getAddressFromGeoJson(curlat,curlng, optionObj, params);
		},

		onComplete(response) {
			this.currLocation = response._responseData.addressInfo.city_do + ' '+response._responseData.addressInfo.gu_gun
			this.selectLocation = this.currLocation
		},

		onProgress(){
		},

		onError(){
			// this.isAlert.isOpenAlert= true;
			// this.isAlert.title=''
			// this.isAlert.content='지역 필터로 위치를 선택해주세요'
		},

		handleAlertClose1() {
			this.isAlert1.isOpenAlert = false;
			this.$router.push({name:'AiMain'})
		},

		//////////////////////////////////////////////////

	},
	components: {
		Header,
		BottomSheet,
		ShopCard,
		Alert,
		Modal
	},
	mounted() {
		this.$nextTick(function () {
			if(this.estimateSeq){
				this.fnGetZoneCode();
				this.fnGetCurrGeoCode();
			}
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/ai/AiShopList.vue